import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { SvgIcon } from '@adsk/bim360-matrix-react-components';
import { childrenType, transitionType } from '../../../../../constants/proptype-validation';
import lodashGet from 'lodash/get';

class Modal extends PureComponent {
  constructor() {
    super(...arguments);

    this.handleBackdropClick = this._handleBackdropClick.bind(this);
    this.handleKeyboard = this._handleKeyboard.bind(this);
  }

  componentWillMount() {
    if (this.props.isOpen && this.props.keyboard) {
      this.setKeydownHandlers(true);
    }
  }

  componentWillUpdate(nextProps) {
    if (this.props.isOpen !== nextProps.isOpen || this.props.keyboard !== nextProps.keyboard) {
      if (nextProps.isOpen && nextProps.keyboard) {
        this.setKeydownHandlers(true);
      } else if (this.props.isOpen && this.props.keyboard) {
        this.setKeydownHandlers(false);
      }
    }
  }

  // Modal sub components (stateless)
  static Header({ children }) {
    return (
      <div className="isui-modal-header">
        {children}
      </div>
    );
  }

  static Body({ children, removeBodyEdges }) {
    const modalBodyClassName = cx('isui-modal-body', {
      'isui-modal-body__no-padding': removeBodyEdges,
    });

    return (
      <div className={modalBodyClassName}>
        {children}
      </div>
    );
  }

  static Footer({ children }) {
    return (
      <div className="isui-modal-footer">
        {children}
      </div>
    );
  }

  static CloseButton({ setIsOpen }) {
    return (
      <div className="isui-modal-close-btn" onClick={() => { setIsOpen(false); }}>
        <SvgIcon svgId="modal-close" />
      </div>
    );
  }

  setKeydownHandlers(enable) {
    enable ? window.document.addEventListener('keyup', this.handleKeyboard) : window.document.removeEventListener('keyup', this.handleKeyboard);
  }

  closest(elm, string) {
    let element = elm;

    while (element && !(lodashGet(element, 'className.baseVal', element.className) || '').split(' ').includes(string)) {
      element = element.parentNode;
    }

    return element;
  }

  _handleBackdropClick(evt) {
    if (this.props.backdropClose && this.closest(evt.target, 'isui-modal-container') && !this.closest(evt.target, 'isui-modal')) {
      this.props.setIsOpen(false);
    }
  }

  _handleKeyboard(evt) {
    // eslint-disable-next-line default-case
    switch (evt.keyCode) {
      case 27: // ESC
        this.props.setIsOpen(false);
        break;
    }
  }

  render() {
    if (!this.props.isOpen) {
      return null;
    }

    const { className, backdrop, showNextPrev, showNext, showPrev } = this.props;
    const modalContainerStyles = cx('isui-modal-container', {
      'isui-modal-container-backdrop': backdrop,
      [className]: className,
    });

    return (
      <div className={modalContainerStyles} onClick={this.handleBackdropClick}>
        <div className="isui-modal">
          {showNextPrev && showPrev ? <div className="isui-modal-prev-btn" onClick={showPrev} /> : null}
          <div className="isui-modal-content">
            {this.props.children}
          </div>
          {showNextPrev && showNext ? <div className="isui-modal-next-btn" onClick={showNext} /> : null}
        </div>
      </div>
    );
  }
}

Modal.displayName = 'Modal';

Modal.defaultProps = {
  isOpen: false,
  removeBodyEdges: false,
  keyboard: true,
  backdrop: true,
  backdropClose: true,
  showNextPrev: false,
};

Modal.propTypes = {
  children: childrenType.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  keyboard: PropTypes.bool.isRequired,
  backdrop: PropTypes.bool.isRequired,
  backdropClose: PropTypes.bool.isRequired,
  transition: transitionType,
  className: PropTypes.string,
  showNextPrev: PropTypes.bool.isRequired,
  showNext: PropTypes.func,
  showPrev: PropTypes.func,
  removeBodyEdges: PropTypes.bool,
};

export default Modal;
